// LegalLayout — branded shell for long-form legal pages (Privacy, Terms,
// Cookie, Refund). DS aesthetic: cream paper, Archivo Black title, sienna
// links, RevealNav + SiteFooter, centered ~780px prose for readability.
import RevealNav from "@/components/RevealNav";
import SiteFooter from "@/components/SiteFooter";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div>
      <RevealNav />
      <main className="ds-container pt-32 pb-12" style={{ maxWidth: 820 }}>
        <header className="mb-10 pb-8 border-b border-border">
          <p className="overline mb-3">legal</p>
          <h1 className="text-4xl lg:text-5xl mb-2">{title}</h1>
          {updated && <p className="text-sm text-muted-foreground">Last updated: {updated}</p>}
        </header>
        <article className="legal-prose">{children}</article>
        <div className="legal-disclaimer">
          This document is provided for informational purposes and does not constitute legal
          advice. Consult a qualified attorney to ensure compliance with applicable laws.
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
